import { Loadable, useRecoilValueLoadable } from 'recoil'

import { Stock, stockState } from '../store'

import useCustomSearchParams from './useCustomSearchParams'
import {useChartStockCode} from "../../@shared/stores/chartStore";

export default function useStock(initialCode?: string): Loadable<Stock> {
  const { getParams } = useCustomSearchParams()
  const code = initialCode || getParams('code', '')
  const {stockCode} = useChartStockCode()

  return useRecoilValueLoadable(stockState(code || stockCode))
}
